import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { StudentDetailsView, studentQueryOptions } from '@/modules/students'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute(
  '/_auth/students-and-classes/students/$studentId/details'
)({
  component: StudentDetailsView,
  loader: async ({ context, params: { studentId } }) => {
    const { fullName } = await context.queryClient.ensureQueryData(
      studentQueryOptions(studentId)
    )
    return fullName
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.details', { ns: 'students' })
    ])
})
